import AttachmentClient from 'models/attachment'

export default class ImagePickerItem {
  /**
   * @param url String
   * @param file File
   * @param source ImageSource
   */
  constructor(url = null, file = null, source = null) {
    this.url = url || (source && source.url)
    this.file = file
    this.source = source
  }

  get isValid() {
    return false
  }

  get isDefaultImage() {
    return false
  }
}

export class ImagePickerUploadItem extends ImagePickerItem {
  /**
   * @param url String
   * @param file File
   */
  constructor(url = null, file = null) {
    super(url, file)
  }

  get isValid() {
    return this.url !== null && this.file !== null
  }

  get isDefaultImage() {
    return false
  }

  upload() {
    return AttachmentClient.upload(this.file)
  }
}

export class ImagePickerSourceItem extends ImagePickerItem {
  /**
   * @param source ImageSource
   */
  constructor(source = null) {
    super(null, null, source)
  }

  get isValid() {
    return this.source !== null
  }

  get isDefaultImage() {
    return true
  }

  upload() {
    return AttachmentClient.uploadRemoteUrl(this.url)
  }
}
